import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7862277c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, "<", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, ">", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cerrar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_sampling_point_image_component = _resolveComponent("sampling-point-image-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "card-chart" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: _ctx.chartId,
                  style: {"width":"100%","height":"50.9vh"}
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      "show-close": false,
      title: _ctx.isAppDemo ? _ctx.samplingPoint?.id : _ctx.samplingPoint?.name
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = false)),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.currentIndex !== undefined || _ctx.currentIndexTmoa !== undefined)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "arrow-column left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevImg())),
              title: "Imagen anterior"
            }, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.visible)
          ? (_openBlock(), _createBlock(_component_sampling_point_image_component, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.seeImages())),
              images: 
        _ctx.lastImage
          ? [
              {
                ..._ctx.lastImage,
                ...{ title: _ctx.isAppDemo ? _ctx.samplingPoint?.id : _ctx.samplingPoint?.name },
              },
            ]
          : []
      ,
              class: "__sampling-point-image"
            }, null, 8, ["images"]))
          : _createCommentVNode("", true),
        (_ctx.currentIndex !== undefined || _ctx.currentIndexTmoa !== undefined)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "arrow-column right",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextImg())),
              title: "Imagen siguiente"
            }, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}